import { createEffect, Actions, ofType } from '@ngrx/effects';
import { asyncScheduler, timer, interval } from 'rxjs';
import {
  withLatestFrom,
  filter,
  switchMap,
  delayWhen,
  takeUntil,
  bufferWhen,
  map
} from 'rxjs/operators';
import { select, Store } from '@ngrx/store';
import { SharedState, selectCalendarWeekOf } from '../../reducer';
import { UpdateDeals } from '../actions';
import { Injectable } from '@angular/core';
import {
  LiveUpdateService,
  getMessageDelay,
  THROTTLE_DELAY
} from '../../../services/live-update.service';
import {
  CalendarLivePollingStart,
  CalendarLivePollingActionTypes
} from './actions';

@Injectable()
export class CalendarLivePollingEffect {
  private calendarLiveUpdateStop$ = this.actions$.pipe(
    ofType(CalendarLivePollingActionTypes.StopCalendarPolling)
  );

  
  public readonly livePolling = createEffect(() => (scheduler = asyncScheduler) =>
    this.actions$.pipe(
      ofType<CalendarLivePollingStart>(
        CalendarLivePollingActionTypes.StartCalendarPolling
      ),
      switchMap(() => {
        return this.liveUpdateService.startPolling().pipe(
          bufferWhen(() => timer(THROTTLE_DELAY, scheduler)),
          delayWhen((messages) =>
            interval(getMessageDelay(messages), scheduler)
          ),
          takeUntil(this.calendarLiveUpdateStop$),
          withLatestFrom(this.store.pipe(select(selectCalendarWeekOf))),
          map(([msgs, calendarWeekOf]) =>
            msgs.filter((msg) => msg.WeekOf === calendarWeekOf)
          ),
          filter((msgs) => msgs.length > 0),
          map(
            (deals) =>
              new UpdateDeals({
                weekOf: deals[0].WeekOf,
                dealIds: deals
                  .map((msg) => msg.DealId)
                  .filter((deal, index, self) => self.indexOf(deal) === index) // ensure distinct deals to load
              })
          )
        );
      })
    ));

  constructor(
    private store: Store<SharedState>,
    private actions$: Actions,
    private liveUpdateService: LiveUpdateService
  ) {}
}
